import React from 'react';
import { PageHeader } from '../components/layout';
import CustomizableDashboard from '../components/dashboard/CustomizableDashboard';
import { UnderConstruction } from '../components/layout';
import { Icon } from '../components/layout/icons/Icons';
import styles from './AnalyticsDashboard.module.css';

const AnalyticsDashboard = () => {
  return (
    <div className={styles.analyticsDashboardPage}>
      <div className={styles.container}>
        <PageHeader 
          title="Analytics Dashboard"
          subtext="Monitor your canvasses, interviews, and insights with customizable widgets"
          size="lg"
        />
        {/* <CustomizableDashboard /> */}
        <UnderConstruction icon={<Icon height="45px" width="45px" name="date_time/update" />} />
      </div>
    </div>
  );
};

export default AnalyticsDashboard;
